import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import ContactForm from "../section-component/contact-form/ContactForm";
// import MapSection from "../section-component/map-section/MapSection";
import ContactInfoBlock from "../section-component/contact-info/ContactInfoBlock";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const ContactIndex = () => {

    return (
        <>
        
 
        <ContactForm />
        {/* <MapSection /> */}
        {/* <ContactInfoBlock /> */}
        
        
        </>
    );
};

export default ContactIndex;